export const initialState = () => ({
  listOffersSeparate: [],
  paginationOffersSeparate: {},
  optionsOffersSeparate: [],
  currentPage: 1,
  separateFilter: {
    name: ""
  }
})
